import { render, staticRenderFns } from "./PesquisaInteligenteArgentina.vue?vue&type=template&id=8551a0f2&scoped=true&lang=pug"
import script from "./PesquisaInteligenteArgentina.vue?vue&type=script&lang=js"
export * from "./PesquisaInteligenteArgentina.vue?vue&type=script&lang=js"
import style0 from "./PesquisaInteligenteArgentina.vue?vue&type=style&index=0&id=8551a0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8551a0f2",
  null
  
)

export default component.exports